module.exports = __webpack_public_path__ + "static/media/steelpaw-gameplay-1.118a067b.webm";